module.exports = __webpack_public_path__ + "static/media/fm1000-st-11.95509761.jpg";